// @flow

type Params = {|
    headerHeight: number,
    headerTopOffset: number,
    frozenHeaderHeight: number,
    arrowHolderHeight: number,
    arrowHolderTop: number,
    containerBottom: number,
    stickyNavHeight: number,
|};
export const getArrowTopPosition = (params: Params): number => {
    const {
        headerHeight,
        headerTopOffset,
        arrowHolderHeight,
        arrowHolderTop,
        containerBottom,
        stickyNavHeight
    } = params;

    const headerBottomOffset = headerTopOffset + headerHeight;
    const arrowHolderBottom = arrowHolderTop + arrowHolderHeight;

    const scrollDiff = !headerHeight && arrowHolderTop > 0 ? 0 : headerTopOffset - arrowHolderTop;

    const topViewportEdge = Math.max(arrowHolderTop, headerBottomOffset);
    const bottomViewportEdge = Math.min(arrowHolderBottom, containerBottom) - stickyNavHeight;

    const arrowViewportHeight = bottomViewportEdge - topViewportEdge;
    const arrowViewportMiddle = arrowViewportHeight / 2;

    return arrowViewportMiddle + scrollDiff + headerHeight;
};
